import { render } from "./AddSupportPage.vue?vue&type=template&id=2b14dd05&ts=true"
import script from "./AddSupportPage.vue?vue&type=script&lang=ts"
export * from "./AddSupportPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__